module.exports = __webpack_public_path__ + "img/NL6175522.9bd824c4.svg";